export const STATUS_IDLE = "STATUS_IDLE";
export const STATUS_UPDATE_NECCESSARY = "STATUS_UPDATE_NECCESSARY";